import { render } from "./tableM.vue?vue&type=template&id=3db95bbd"
import script from "./tableM.vue?vue&type=script&lang=js"
export * from "./tableM.vue?vue&type=script&lang=js"

import "./tableM.vue?vue&type=style&index=0&id=3db95bbd&lang=css"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\小爱到家长护险服务运营平台4.8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__